export const ConvertDateToString = (value?: Date | null, separateSymbol = '/') => {
  if (!value) {
    value = new Date();
  }
  const year = value.getFullYear();
  const month = value.getMonth() + 1;
  const date = value.getDate();
  const monthStr = month < 10 ? '0' + month : month;
  const dateStr = date < 10 ? '0' + date : date;

  if (separateSymbol === '-') {
    return year + separateSymbol + monthStr + separateSymbol + dateStr;
  }
  
  return monthStr + separateSymbol + dateStr + separateSymbol + year;
}
